import { getValue, isPending } from 'mobx-async'
import { observer } from 'mobx-react'
import React, { FC } from 'react'

import { CheckboxBasedFilter } from '@avantstay/backoffice-core'

import { FiltersSharedProps } from '@new/__global/components/Filters/Filters.types'
import { BookingsTapeChartStore } from '@new/domains/bookingsTapeChart/stores/BookingsTapeChartStore'

interface AmenitiesFilterProps extends FiltersSharedProps {
  initialValue?: string[]
  onChange: (value?: string[]) => void
}

const _AmenitiesFilter: FC<AmenitiesFilterProps> = props => {
  const { amenitiesOptions } = BookingsTapeChartStore

  const options = getValue(amenitiesOptions)
  const isLoading = isPending(amenitiesOptions)

  return (
    <CheckboxBasedFilter
      title="Amenities"
      isSearchEnabled
      searchPlaceholder="Search by amenity"
      isLoadingOptions={isLoading}
      options={options}
      {...props}
    />
  )
}
export const AmenitiesFilter = observer(_AmenitiesFilter)
